var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('script',{tag:"component",attrs:{"src":"https://widget.cloudpayments.ru/bundles/cloudpayments.js"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }